import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

function AddCustomerModal({ onClose, onSuccess }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [initialBalance, setInitialBalance] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/add-customer`, { 
        name, 
        phone, 
        address,
        initial_balance: parseFloat(initialBalance) || 0
      });
      
      console.log('Customer added:', response.data);
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error adding customer: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Add New Customer</h2>
        <form onSubmit={handleSubmit}>
          <input 
            type="text" 
            placeholder="Customer Name *" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            required 
          />
          <input 
            type="tel" 
            placeholder="Phone Number *" 
            value={phone} 
            onChange={(e) => setPhone(e.target.value)} 
            required 
          />
          <textarea 
            placeholder="Address" 
            value={address} 
            onChange={(e) => setAddress(e.target.value)} 
            rows="2"
          ></textarea>
          
          <div className="initial-balance-field">
            <label>Initial Balance (if any)</label>
            <input 
              type="number" 
              step="0.01" 
              placeholder="0.00" 
              value={initialBalance} 
              onChange={(e) => setInitialBalance(e.target.value)}
            />
            <small>Positive amount means customer owes you money</small>
          </div>
          
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>
              {loading ? 'Adding...' : 'Add Customer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCustomerModal;